import {get, set, unset, clone} from 'lodash';
import update from "react-addons-update";
import copySpeziesFromCreature from "../Module/copySpeziesFromCreature";
import SettingsFromSpecies from "../Module/SettingsFromSpecies";

const daten = (state = {}, action) => {

  switch (action.type) {

    case 'ADD_VALUE': {
      let newstate = {...state };
      set(newstate, action.pfad, action.value)
      return (newstate)
    }

    case 'UPDATE_VALUE': {
      if (get(state, action.pfad) === action.value) {
        return state
      }
      let newstate = {...state };
      set(newstate, action.pfad, action.value)
      return (newstate)
    }

    case 'ADD_FILE': {
      let newstate =  {...state}

      let obj = {
        name:action.name,
        extension:action.extension,
        id:action.fileUid,
        statusCode:action.statusCode,
        message:null,
      }

      set(newstate, [...action.lineage,action.fileUid], obj)
    
      return (newstate)
    }

    case 'UPDATE_FILE_STATUS': {
      let newstate =  {...state}
      set(newstate, [...action.lineage,action.fileUid, 'statusCode'], action.statusCode)
      set(newstate, [...action.lineage,action.fileUid, 'message'], action.message)
      return (newstate)
    }

    case 'REMOVE_FILE': {
      let newstate =  {...state}
      unset(newstate, [...action.lineage,action.fileUid])
      return (newstate)
    }

    case 'ADD_CREATURE': {
      let newstate =  {...state}
      let creature = action.creature


      let creatureKeys = Object.keys(state.creatures)
      if  (creatureKeys.length > 0) {
        let uniqueIdPrevSibling = creatureKeys[creatureKeys.length-1]
        if (state.creatures[uniqueIdPrevSibling].hasOwnProperty("spezies")) {
          creature.spezies = copySpeziesFromCreature(state.creatures[uniqueIdPrevSibling])
        }
      }
      if (state.hasOwnProperty('spezies')) {
        newstate.creatures[creature.uniqueId] = {...creature, ...SettingsFromSpecies(state.spezies)}
      } else {
        newstate.creatures[creature.uniqueId] = creature
      }
      
      return newstate;
    }

    case 'ADD_CREATURE_NACHZUCHT': {
      let newstate =  {...state}
      let creature = action.creature

      let arrPathCreature = action.path.split('.')
      // Find first Parent
      let arrParentsPath = arrPathCreature.slice()
      arrParentsPath.pop()
      arrParentsPath.pop()
      arrParentsPath.push("parents")
      let parents = get(state, arrParentsPath)
      let firstParent = {}
      if (Object.keys(parents).length) {
        arrParentsPath.push(Object.keys(parents)[0])
        firstParent = get(state, arrParentsPath)
        if (firstParent.hasOwnProperty("spezies")) {
          creature.spezies = copySpeziesFromCreature(firstParent)
        }
      }
      set(newstate, arrPathCreature, creature)
      return (newstate)
      
    }

    case "SPEZIES_SETZEN": {

      let newstate =  {...state}
      let newcreature =  {...get(state, action.lineage), ...SettingsFromSpecies(action.obj)}

      newcreature.spezies = action.obj
      set(newstate, action.lineage, newcreature)

      return (newstate)
    }

    case "SPEZIES_SETZEN_CITES": {

      let newstate =  {...state}

      newstate.spezies = action.obj

      Object.keys(state.creatures).map (
        (key) => {
          console.log(key)
          newstate.creatures[key] = {...state.creatures[key], ...SettingsFromSpecies(action.obj)}
        }
      );


      return (newstate)
    }

    case "ANZAHL_SPEZIES_SETZEN": {
      let newstate =  {...state}
      let lineage = action.lineage.slice()
      lineage.push('anzahl')
      set(newstate, lineage, action.value)
      return (newstate)
    }

    case 'REMOVE_CREATURE': {
      let newstate =  {...state}

      if (action.lineage.length == 1) {
        delete newstate.creatures[action.lineage[0]]
      }
      if (action.lineage.length == 2) {
        delete newstate.creatures[action.lineage[0]].children[action.lineage[1]]
      }
      return (newstate)
    }

    case 'ADD_ENTITY_TO_STATE': {
      let newstate =  {...state}
      set(newstate, action.path, action.entity)
      return (newstate)
    }

    case 'REMOVE_ENTITY_FROM_STATE': {
      let newstate =  {...state}
      unset(newstate, action.path)
      return (newstate)
    }

    default: {
      return state
    }

  }
}

export default daten;
